import { jsx as t, jsxs as a } from "react/jsx-runtime";
import { c as f } from "../index-rKuIKazb.js";
import C from "../Card/index.js";
import l from "../CardLink/index.js";
import d from "../FancyLink/index.js";
import p from "../IconLookup/index.js";
import m from "../LinkButton/index.js";
import o from "../Link/index.js";
import _ from "../LogoLink/index.js";
import v from "../Text/index.js";
import { useTheme as u } from "../ThemeProvider/index.js";
import k from "../Well/index.js";
import L from "../helpers/getCurrentYear.js";
import * as e from "react";
import '../assets/index25.css';/*!
 * Font Awesome Pro 6.7.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const b = {
  prefix: "fas",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
}, x = (n) => /* @__PURE__ */ e.createElement("svg", { width: 70, height: 71, viewBox: "0 0 70 71", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_2484_2947)" }, /* @__PURE__ */ e.createElement("path", { d: "M45.7781 33.4753C45.3327 33.03 44.7287 32.7799 44.0989 32.7799C43.4692 32.7799 42.8652 33.03 42.4198 33.4753L40.7407 35.152C40.3025 35.6057 39.7784 35.9675 39.1989 36.2165C38.6193 36.4654 37.996 36.5965 37.3653 36.6019C36.7346 36.6074 36.1092 36.4872 35.5254 36.2484C34.9417 36.0096 34.4113 35.6569 33.9653 35.2109C33.5193 34.7649 33.1666 34.2345 32.9278 33.6508C32.6889 33.067 32.5688 32.4416 32.5742 31.8108C32.5797 31.1801 32.7108 30.5569 32.9597 29.9773C33.2086 29.3978 33.5705 28.8737 34.0242 28.4355L47.3954 15.0595C50.5611 14.3395 53.8733 14.6358 56.8609 15.9064C59.8485 17.1769 62.3595 19.3571 64.0368 22.1367C65.7141 24.9164 66.4724 28.1542 66.2038 31.3896C65.9353 34.625 64.6535 37.6934 62.5408 40.1585L57.5343 45.2291L45.7781 33.4729V33.4753ZM19.7481 19.1968C22.2056 16.7395 25.4201 15.183 28.8718 14.7787C32.3235 14.3744 35.8106 15.1461 38.7694 16.969L30.6636 25.0773C28.908 26.8294 27.9072 29.1986 27.8752 31.6787C27.8431 34.1588 28.7823 36.5531 30.492 38.35C32.2018 40.1469 34.5465 41.2039 37.0251 41.295C39.5038 41.3862 41.9198 40.5044 43.7569 38.838L44.0989 38.5126L54.1761 48.5874L44.0989 58.6645C43.2082 59.555 42.0002 60.0552 40.7407 60.0552C39.4812 60.0552 38.2732 59.555 37.3824 58.6645L19.7457 41.0278C16.8509 38.1327 15.2246 34.2063 15.2246 30.1123C15.2246 26.0182 16.8509 22.0918 19.7457 19.1968H19.7481Z", fill: "#108EC1" }), /* @__PURE__ */ e.createElement("path", { d: "M42.5925 31.7761C42.6023 31.7859 42.6123 31.7951 42.6227 31.8039L54.3487 43.5299C54.4429 43.6241 54.5707 43.6768 54.7039 43.6764C54.837 43.676 54.9645 43.6224 55.0581 43.5277L60.0646 38.4571C60.0728 38.4487 60.0808 38.4401 60.0884 38.4311C62.2696 35.8862 63.5928 32.7184 63.8701 29.3782C64.1474 26.038 63.3645 22.6954 61.6328 19.8257C59.9012 16.956 57.3089 14.7052 54.2245 13.3935C51.1401 12.0818 47.7207 11.7759 44.4525 12.5192C44.3606 12.5401 44.2764 12.5866 44.2098 12.6533L30.8416 26.0263C30.3417 26.5099 29.9428 27.0881 29.6683 27.7273C29.3931 28.3678 29.2483 29.0567 29.2422 29.7538C29.2362 30.4509 29.369 31.1422 29.633 31.7874C29.897 32.4326 30.2868 33.0188 30.7797 33.5117C31.2727 34.0046 31.8588 34.3945 32.504 34.6584C33.1492 34.9224 33.8406 35.0553 34.5377 35.0492C35.2347 35.0431 35.9237 34.8983 36.5642 34.6232C37.2033 34.3486 37.7814 33.9498 38.2651 33.45L39.9411 31.7763L39.9413 31.7761C40.2929 31.4246 40.7697 31.2272 41.2669 31.2272C41.7641 31.2272 42.2409 31.4246 42.5925 31.7761ZM36.291 15.2698C36.3991 15.1616 36.4518 15.0099 36.434 14.8581C36.4162 14.7062 36.3299 14.5708 36.1997 14.4906C33.145 12.6087 29.545 11.812 25.9816 12.2294C22.4314 12.6452 19.1242 14.2418 16.5907 16.7623C16.5802 16.7712 16.5699 16.7806 16.5601 16.7905C13.5715 19.7793 11.8926 23.8329 11.8926 28.0595C11.8926 32.2862 13.5715 36.3397 16.5601 39.3286L16.5601 39.3286L34.1969 56.9653L34.1969 56.9654C35.1814 57.9496 36.5165 58.5025 37.9087 58.5025C39.3008 58.5025 40.6359 57.9496 41.6204 56.9654L41.6205 56.9653L51.6976 46.8882C51.7914 46.7944 51.844 46.6672 51.844 46.5346C51.844 46.402 51.7913 46.2748 51.6975 46.181L41.6204 36.1063C41.4286 35.9145 41.1188 35.9107 40.9223 36.0976L40.5847 36.4188C38.8447 37.995 36.5577 38.829 34.2115 38.7426C31.8633 38.6563 29.642 37.6549 28.0222 35.9526C26.4025 34.2503 25.5127 31.982 25.5431 29.6324C25.5735 27.2829 26.5215 25.0383 28.1847 23.3784L28.1851 23.378L36.291 15.2698Z", fill: "#15A5DF", stroke: "black", strokeLinejoin: "round" })), /* @__PURE__ */ e.createElement("g", { filter: "url(#filter0_d_2484_2947)" }, /* @__PURE__ */ e.createElement("path", { d: "M34.1266 41.2836V45.6458C34.1266 49.2592 28.2666 52.1892 21.0399 52.1892C13.8131 52.1892 7.95312 49.2592 7.95312 45.6458V41.2836C7.95312 44.897 13.8131 47.8269 21.0399 47.8269C28.2666 47.8269 34.1266 44.897 34.1266 41.2836ZM7.95312 48.554C7.95312 52.1674 13.8131 55.0973 21.0399 55.0973C28.2666 55.0973 34.1266 52.1674 34.1266 48.554V52.9162C34.1266 56.5296 28.2666 59.4596 21.0399 59.4596C13.8131 59.4596 7.95312 56.5296 7.95312 52.9162V48.554ZM21.0399 44.9188C13.8131 44.9188 7.95312 41.9888 7.95312 38.3754C7.95312 34.762 13.8131 31.832 21.0399 31.832C28.2666 31.832 34.1266 34.762 34.1266 38.3754C34.1266 41.9888 28.2666 44.9188 21.0399 44.9188Z", fill: "#7AE0A0" }), /* @__PURE__ */ e.createElement("path", { d: "M34.6266 41.2836C34.6266 41.0074 34.4027 40.7836 34.1266 40.7836C33.8505 40.7836 33.6266 41.0074 33.6266 41.2836C33.6266 42.7988 32.3849 44.3054 30.0697 45.4631C27.7844 46.6057 24.5924 47.3269 21.0399 47.3269C17.4873 47.3269 14.2953 46.6057 12.0101 45.4631C9.69482 44.3054 8.45312 42.7988 8.45312 41.2836C8.45312 41.0074 8.22927 40.7836 7.95312 40.7836C7.67698 40.7836 7.45312 41.0074 7.45312 41.2836V45.6458C7.45312 47.744 9.1414 49.509 11.5628 50.7197C14.0142 51.9454 17.3657 52.6892 21.0399 52.6892C24.7141 52.6892 28.0655 51.9454 30.5169 50.7197C32.9383 49.509 34.6266 47.744 34.6266 45.6458V41.2836ZM8.45312 48.554C8.45312 48.2778 8.22927 48.054 7.95312 48.054C7.67698 48.054 7.45312 48.2778 7.45312 48.554V52.9162C7.45312 55.0144 9.1414 56.7794 11.5628 57.9901C14.0142 59.2158 17.3657 59.9596 21.0399 59.9596C24.7141 59.9596 28.0655 59.2158 30.5169 57.9901C32.9383 56.7794 34.6266 55.0144 34.6266 52.9162V48.554C34.6266 48.2778 34.4027 48.054 34.1266 48.054C33.8505 48.054 33.6266 48.2778 33.6266 48.554C33.6266 50.0692 32.3849 51.5758 30.0697 52.7335C27.7844 53.8761 24.5924 54.5973 21.0399 54.5973C17.4873 54.5973 14.2953 53.8761 12.0101 52.7335C9.69482 51.5758 8.45312 50.0692 8.45312 48.554ZM7.45312 38.3754C7.45312 40.4735 9.1414 42.2386 11.5628 43.4493C14.0142 44.675 17.3657 45.4188 21.0399 45.4188C24.7141 45.4188 28.0655 44.675 30.5169 43.4493C32.9383 42.2386 34.6266 40.4735 34.6266 38.3754C34.6266 36.2773 32.9383 34.5122 30.5169 33.3015C28.0655 32.0758 24.7141 31.332 21.0399 31.332C17.3657 31.332 14.0142 32.0758 11.5628 33.3015C9.1414 34.5122 7.45312 36.2773 7.45312 38.3754Z", stroke: "black", strokeLinejoin: "round" })), /* @__PURE__ */ e.createElement("g", { filter: "url(#filter1_d_2484_2947)" }, /* @__PURE__ */ e.createElement("path", { d: "M21.0399 45.2117C13.8131 45.2117 7.95312 42.2818 7.95312 38.6684C7.95312 35.055 13.8131 32.125 21.0399 32.125C28.2666 32.125 34.1266 35.055 34.1266 38.6684C34.1266 42.2818 28.2666 45.2117 21.0399 45.2117Z", fill: "white" }), /* @__PURE__ */ e.createElement("path", { d: "M7.45312 38.6684C7.45312 40.7665 9.1414 42.5316 11.5628 43.7423C14.0142 44.968 17.3657 45.7117 21.0399 45.7117C24.7141 45.7117 28.0655 44.968 30.5169 43.7423C32.9383 42.5316 34.6266 40.7665 34.6266 38.6684C34.6266 36.5702 32.9383 34.8052 30.5169 33.5944C28.0655 32.3688 24.7141 31.625 21.0399 31.625C17.3657 31.625 14.0142 32.3688 11.5628 33.5944C9.1414 34.8052 7.45312 36.5702 7.45312 38.6684Z", stroke: "black", strokeLinejoin: "round" })), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("filter", { id: "filter0_d_2484_2947", x: 6.95312, y: 30.832, width: 28.1738, height: 30.7902, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ e.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ e.createElement("feOffset", { dy: 1.16327 }), /* @__PURE__ */ e.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ e.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" }), /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2484_2947" }), /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2484_2947", result: "shape" })), /* @__PURE__ */ e.createElement("filter", { id: "filter1_d_2484_2947", x: 6.95312, y: 31.125, width: 28.1738, height: 16.2492, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ e.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ e.createElement("feOffset", { dy: 1.16327 }), /* @__PURE__ */ e.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ e.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" }), /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2484_2947" }), /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2484_2947", result: "shape" })), /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_2484_2947" }, /* @__PURE__ */ e.createElement("rect", { width: 57, height: 57, fill: "white", transform: "translate(9.4082 6.53125)" })))), g = "_layout_1lvxp_2", y = "_secondary_1lvxp_8", E = "_header_1lvxp_12", w = "_contact_1lvxp_19", N = "_contactLink_1lvxp_26", A = "_content_1lvxp_30", M = "_linksContainer_1lvxp_42", B = "_links_1lvxp_42", F = "_affiliates_1lvxp_57", S = "_affiliateText_1lvxp_67", Z = "_affiliateDescription_1lvxp_72", V = "_affiliateLink_1lvxp_77", I = "_footer_1lvxp_83", T = "_copyright_1lvxp_92", O = "_footerLinks_1lvxp_93", P = "_icon_1lvxp_108", j = "_dark_1lvxp_112", D = "_achievableLink_1lvxp_137", r = {
  layout: g,
  secondary: y,
  header: E,
  contact: w,
  contactLink: N,
  content: A,
  linksContainer: M,
  links: B,
  affiliates: F,
  affiliateText: S,
  affiliateDescription: Z,
  affiliateLink: V,
  footer: I,
  copyright: T,
  footerLinks: O,
  icon: P,
  dark: j,
  achievableLink: D
}, G = ({ CustomLink: n }) => /* @__PURE__ */ a(C, { className: r.affiliates, children: [
  /* @__PURE__ */ t(x, {}),
  /* @__PURE__ */ a("div", { children: [
    /* @__PURE__ */ t("div", { className: r.affiliateText, children: "Proven success at scale" }),
    /* @__PURE__ */ t("div", { className: r.affiliateDescription, children: "Partner with Achievable to modernize your training program, increase your pass rates, and help people achieve their professional goals" })
  ] }),
  /* @__PURE__ */ t(
    d,
    {
      className: r.affiliateLink,
      CustomLink: n,
      href: "https://achievable.me/enterprise/",
      to: "/enterprise/",
      withArrow: !0,
      children: "Enterprise"
    }
  )
] }), t3 = (n) => {
  const { CustomLink: i, secondary: c } = n, s = u(), h = f(r[s], c && r.secondary);
  return /* @__PURE__ */ t("div", { className: h, children: /* @__PURE__ */ a(k, { className: r.layout, children: [
    /* @__PURE__ */ a("div", { className: r.header, children: [
      /* @__PURE__ */ t(
        _,
        {
          className: r.achievableLink,
          CustomLink: i,
          href: "https://achievable.me/",
          to: "/"
        }
      ),
      /* @__PURE__ */ a("div", { className: r.contact, children: [
        /* @__PURE__ */ t(v, { size: "bear", weight: "bold", children: "Have questions?" }),
        /* @__PURE__ */ a(m, { href: "tel:415-831-7733", children: [
          "Call/text us ",
          /* @__PURE__ */ t(p, { className: r.icon, iconX: b })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a("div", { className: r.content, children: [
      /* @__PURE__ */ t(G, { CustomLink: i }),
      /* @__PURE__ */ a("div", { className: r.linksContainer, children: [
        /* @__PURE__ */ a("div", { className: r.links, children: [
          /* @__PURE__ */ t(
            l,
            {
              CustomLink: i,
              href: "https://achievable.me/resources/",
              to: "/resources/",
              children: "resources"
            }
          ),
          /* @__PURE__ */ t(
            l,
            {
              CustomLink: i,
              href: "https://achievable.me/tutors/",
              to: "/tutors/",
              children: "tutors"
            }
          ),
          /* @__PURE__ */ t(
            l,
            {
              CustomLink: i,
              href: "https://achievable.me/awards/",
              to: "/awards/",
              children: "awards"
            }
          ),
          /* @__PURE__ */ t(
            l,
            {
              CustomLink: i,
              href: "https://achievable.me/reviews/",
              to: "/reviews/",
              children: "reviews"
            }
          )
        ] }),
        /* @__PURE__ */ a("div", { className: r.links, children: [
          /* @__PURE__ */ t(
            l,
            {
              href: "https://app.achievable.me/study/achievable/catalog",
              target: "_blank",
              children: "courses"
            }
          ),
          /* @__PURE__ */ t(
            l,
            {
              href: "https://blog.achievable.me",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "blog"
            }
          ),
          /* @__PURE__ */ t(
            l,
            {
              href: "https://www.youtube.com/@Achievable/featured",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "youtube"
            }
          ),
          /* @__PURE__ */ t(
            l,
            {
              href: "https://achievable.podbean.com",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "podcast"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a("div", { className: r.footer, children: [
      /* @__PURE__ */ a("div", { className: r.copyright, children: [
        "All rights reserved. ©2016 - ",
        L(),
        " Achievable, Inc."
      ] }),
      /* @__PURE__ */ a("div", { className: r.footerLinks, children: [
        /* @__PURE__ */ t(
          o,
          {
            href: "https://achievable.me/privacy",
            rel: "noopener noreferrer",
            target: "_blank",
            children: "Privacy"
          }
        ),
        /* @__PURE__ */ t(
          o,
          {
            href: "https://achievable.me/cookie",
            rel: "noopener noreferrer",
            target: "_blank",
            children: "Cookie"
          }
        ),
        /* @__PURE__ */ t(
          o,
          {
            href: "https://achievable.me/terms",
            rel: "noopener noreferrer",
            target: "_blank",
            children: "Terms"
          }
        ),
        /* @__PURE__ */ t(
          o,
          {
            CustomLink: i,
            href: "https://achievable.me/affiliates/",
            to: "/affiliates/",
            children: "Affiliate"
          }
        ),
        /* @__PURE__ */ t(
          o,
          {
            CustomLink: i,
            href: "https://achievable.me/bug-bounty/",
            to: "/bug-bounty/",
            children: "Security"
          }
        ),
        /* @__PURE__ */ t(o, { CustomLink: i, href: "https://achievable.me/faq/", to: "/faq/", children: "FAQ" })
      ] })
    ] })
  ] }) });
};
export {
  t3 as default
};
